"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var CustomerInformationSummaryStyles_1 = require("./CustomerInformationSummaryStyles");
var CustomerInformationSummary = function () {
    var deal = useCheckoutContext_1.default().deal;
    if (!deal) {
        return null;
    }
    var _a = deal.customer || {}, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, phone = _a.phone;
    var styles = CustomerInformationSummaryStyles_1.default();
    return (<>
      <core_1.Typography className={styles.item} variant="body1" data-test="checkout:customerInformation:summary:email">
        {email}
      </core_1.Typography>
      <core_1.Typography className={styles.item} variant="body1" data-test="checkout:customerInformation:summary:name">
        {firstName + " " + lastName}
      </core_1.Typography>
      <core_1.Typography className={styles.item} variant="body1" data-test="checkout:customerInformation:summary:phone">
        {phone}
      </core_1.Typography>
    </>);
};
exports.default = CustomerInformationSummary;
